import * as React from 'react';

export const Logo = ( props: React.SVGProps<SVGSVGElement> ) => {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 92 92"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M46.429 5.948l-35.093 20.02V66.01l35.093 20.02L81.52 66.01V25.968L46.43 5.948zm39.428 17.546L46.43 1 7 23.494v44.99l39.429 22.494 39.428-22.494v-44.99z"
				fill="currentColor"
			/>
			<path
				d="M56.15 45.401c2.384.535 4.216 1.603 5.495 3.206 1.314 1.568 1.97 3.599 1.97 6.092 0 3.207-1.158 5.683-3.473 7.428-2.282 1.71-5.669 2.565-10.162 2.565H33.286V27.286h15.657c4.044 0 7.172.837 9.384 2.511 2.247 1.675 3.37 4.044 3.37 7.108 0 2.066-.501 3.83-1.504 5.29-.967 1.425-2.315 2.494-4.043 3.206zM37.122 30.545V44.12h11.562c2.938 0 5.202-.57 6.792-1.71 1.59-1.176 2.384-2.868 2.384-5.077s-.794-3.883-2.384-5.023c-1.59-1.176-3.854-1.764-6.792-1.764H37.122zm12.806 30.888c3.25 0 5.703-.57 7.362-1.71 1.66-1.14 2.489-2.922 2.489-5.344 0-4.667-3.284-7-9.85-7H37.121v14.054h12.806z"
				fill="currentColor"
			/>
		</svg>
	);
};

